/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { map, groupBy } from 'lodash';
import { ActionButton } from '@blend/enterprise-components';

import { DocumentWithTag } from 'blb-ui-types/BridgeTypes';

import { DocRowCluster } from './DocRowCluster';
import { useParams } from 'react-router-dom';
import { openDocumentViewer } from 'blb-components/AuthenticatedApp/DashboardPage/DocumentActions';

const styles = StyleSheet.create({
  buttonWrapper: {
    marginRight: 8,
  },
  downloadButtonsWrapper: {
    display: 'flex',
  },
  errorContainer: {
    marginBottom: 8,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 24,
  },
});

export namespace DocsTable {
  export interface Props {
    documents: DocumentWithTag[];
    handleClose: () => void;
    isUploaded: boolean;
  }
}

export const DocsTable: React.FC<DocsTable.Props> = ({ documents, handleClose, isUploaded }) => {
  const { loanId } = useParams<{ loanId: string }>();

  const docsBySentDate = groupBy(documents, 'sentOn');
  // ensure latest first order remains
  const sortedSentDateKeys = Object.keys(docsBySentDate).sort((a, b) => (a > b ? -1 : 1));

  return (
    <React.Fragment>
      {map(sortedSentDateKeys, (sentOn, idx) => (
        <DocRowCluster
          documentCluster={docsBySentDate[sentOn]}
          isFirst={idx === 0}
          isUploaded={isUploaded}
          key={sentOn}
          sentOn={sentOn}
        />
      ))}
      <div className={css(styles.footer)}>
        <div className={css(styles.downloadButtonsWrapper)}>
          <ActionButton
            id="it-DocsTable-View"
            label="View documents"
            onClick={() => openDocumentViewer(loanId)}
            theme="secondary"
          />
        </div>
        <div>
          <ActionButton id="it-DocsTable-close" label="Close" onClick={handleClose} theme="primary" />
        </div>
      </div>
    </React.Fragment>
  );
};

DocsTable.displayName = 'DocsTable';
